.content {
  border-radius: 12px;
  overflow-x: hidden;
}

.root {
  &[data-variant='multi'] section[data-modal-content]:before {
    background-image: none;
    display: none;
  }

  &[data-variant='multi'] section[data-modal-content] {
    background: none;
    box-shadow: none;
  }

  &[data-variant='multi'] .mantine-Modal-body {
    padding: 0;
    background: transparent;
  }
}

.title {
  font-size: var(--mantine-font-size-lg);
  font-weight: 600;
}

.header {
  --nav-height: 44px;
  margin-top: var(--nav-height);
  padding: var(--mantine-spacing-lg);
  padding-bottom: 0;

  &:before {
    content: '';
    position: absolute;
    top: calc(var(--nav-height) * -1);
    bottom: 0;
    height: var(--nav-height);
    /* Width beyond modal size to fix aliasing issue with border-radius */
    width: calc(100% + 10px);
    left: -5px;
    background-size: 100% 100%;
    background: linear-gradient(
        4deg,
        var(--mantine-color-brand-7) 0%,
        var(--mantine-color-brand-6) 23%,
        var(--mantine-color-brand-4) 100%
      )
      no-repeat center;
  }

  h2 {
    margin-top: 8px;
  }

  button {
    color: white;
    position: absolute;
    top: calc(var(--nav-height) * -1 + 8px);
    right: var(--mantine-spacing-sm);
  }

  button:hover {
    background: rgba(255, 255, 255, 0.1);
  }
}

.body {
  padding: var(--mantine-spacing-md) var(--mantine-spacing-lg) var(--mantine-spacing-lg)
    var(--mantine-spacing-lg);
}
